import CallError from '../../utils/CallError';
import fetchAndSetInSessionStorage from '../../utils/fetchAndSetInSessionStorage';
import { settings } from './staticData';

/**
 * Get EC standard tags
 * @return {Promise<{value: string, label: string}[]>}
 */
export default async (_params, signal = null) => {
  return await fetchAndSetInSessionStorage('standardTags', async () => {
    let content;
    const response = await fetch(`${settings.endpoint}/get-standard-tags`, {
      signal,
      headers: {
        Accept: 'application/json',
      },
    });
    content = await response.text();
    try {
      content = JSON.parse(content);
    } catch (e) {
      // response is not json
    }

    if (!response.ok) {
      throw new CallError('http', content, response.status, { message: response.statusText });
    } else {
      content = content?.tags;
    }
    return content;
  });
};
